import Home from '@App/pages/Home/Home';
import RegisterEmployer from '@App/pages/RegisterEmployer/RegisterEmployer';
import RegisterJobcoach from '@App/pages/RegisterJobcoach/RegisterJobcoach';
import SharedBase from '@App/components/SharedBase/SharedBase';
import SharedCompanyInfo from '@App/components/SharedCompanyInfo/SharedCompanyInfo';
import JobVacancies from '@App/pages/JobVacancies/JobVacancies';
import Filter from '@App/pages/Filter/Filter';
import JobVacancy from '@App/pages/JobVacancy/JobVacancy';
import MobilityPlan from '@App/pages/MobilityPlan/MobilityPlan';
import Admin from '@App/pages/Admin/Admin';
import About from '@App/pages/About/About';
import NoMatch from '@App/pages/NoMatch/NoMatch';

const routes = [
  {
    path: '/',
    element: <Home />,
    title: 'Home',
  },
  {
    path: '/werkgever',
    element: <RegisterEmployer />,
    title: 'Home',
  },
  {
    path: '/jobcoach',
    element: <RegisterJobcoach />,
    title: 'Home',
  },
  {
    path: '/admin',
    element: <Admin />,
    title: 'Admin',
  },
  {
    element: <SharedBase />,
    children: [
      {
        path: '/vacatures',
        element: <JobVacancies />,
        title: 'Vacatures',
        actions: ['filter', 'company-search'],
      },
      {
        path: '/vacatures/filter',
        element: <Filter />,
        title: 'Filter',
        actions: ['list'],
      },
      {
        element: <SharedCompanyInfo />,
        children: [
          {
            path: '/:companyId',
            element: <MobilityPlan />,
            title: 'Bedrijf',
            actions: [],
          },
          {
            path: '/:companyId/:vacancyId',
            element: <JobVacancy />,
            title: 'Vacature',
            actions: ['list', 'print'],
          },
          {
            path: '/:companyId/:vacancyId/mobiliteitsaanbod',
            element: <MobilityPlan />,
            title: 'Mobiliteitsaanbod',
            actions: ['list', 'print'],
          },
        ],
      },
    ],
  },
  {
    path: '/meer-info',
    element: <About />,
    title: 'About',
  },
  {
    path: '*',
    element: <NoMatch />,
  },
];

export default routes;